import React, {useEffect, useState} from 'react'
import {confirmAlert} from "react-confirm-alert";
import {connect, useSelector} from "react-redux";

// components
import TranslateItem from "../genericComponents/translateItem";
import {GenericButton} from "./customButtons";
import {genericActions} from "../../redux/actions/generics/GenericActions";
import {genericIndexedActions} from "../../redux/actions/generics/GenericIndexedActions";
import {getStateByPath} from "../../redux/selectors";

const TranslateButton = props => {
    const [app, setApp] = useState(null)
    const { item, service = false, askForConfirmation = true,path= null } = props
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const {app:applicative} =props.mainProps

    useEffect(() => {
        if(!!props.path){
            setApp(componentState?.data?.app)
            return
        }

        setApp(applicative);
    }, [componentState, applicative]);


    const confirmTranslation = () => confirmAlert({
        closeOnEscape: false,
        closeOnClickOutside:false,
        customUI: ({onClose}) => <TranslateItem
            itemID      = { item?.id }
            fbDB        = { app?.fbDataBase?.id }
            appID       = { app?.id }
            translatedLangs   = { item?.translatedLangs}
            onClose     = { onClose }
            translate   = { (itemID, fbDB) => onTranslate(itemID, fbDB, onClose) }
        />
    });

    const onTranslate = (itemID, fbDB, onClose) => !path
        ? genericActions.translate(service, itemID, {
                db: fbDB,
                app: app?.id,
            },
            onClose)
        : genericIndexedActions.translate(path, service, itemID, {
                db: fbDB,
                app: app?.id,
            },
            onClose)


    // Recorre los elementos de item.translatedLangs, si algun elemento de esta lista tiene su valor translated = false, muestra el botón de traducción en danger-secondary
    const showTranslateButton = () => {
        if(item?.translatedLangs) {
            for (let i = 0; i < item.translatedLangs.length; i++) {
                if (!item.translatedLangs[i].translated) {
                    return true;
                }
            }
        }
        return false;

    }

    return showTranslateButton() ?
        <GenericButton
            style={ 'danger-secondary' }
            toolTip={'Este registro no cuenta con todas sus traducciones. Haz click para traducirlo completamente.'}
            icon={'fa-language'}
            permission={'search'}
            onClick={askForConfirmation ? confirmTranslation : _ => onTranslate(item?.id, app?.fbDataBase?.id, _ => {})}
        /> : <GenericButton
            style={ 'table'}
            toolTip={'Traducido'}
            icon={'fa-language'}
            permission={'search'}
            onClick={_ => {}}
        />
}

const mapStateToProps = state => ({ mainProps : state.mainProps })
const mapActionsToProps = ({})

export default connect(mapStateToProps, mapActionsToProps)(TranslateButton)